import {
    createComponents,
    NO_PATTERN_BUSINESS_LOGIC,
} from '@vfde-brix/ws10/core';
import {
    ACCORDION_BASE_CLASSNAME,
    createAccordion,
} from '@vfde-brix/ws10/accordion';

const SELECTOR_ACCORDION = `.${ACCORDION_BASE_CLASSNAME}`;

/**
 * Creates a WS10 Accordion component.
 */
export const mountAccordions = () =>
    createComponents(SELECTOR_ACCORDION, createAccordion, NO_PATTERN_BUSINESS_LOGIC);
